var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Widgets',{attrs:{"initial-definition":_vm.definition,"available-elements":_vm.availableElements,"default-widgets":_vm.defaultWidgets,"options":_vm.options,"context":_vm.context,"set-context":_vm.setDefinition}})}
var staticRenderFns = []

export { render, staticRenderFns }